module.exports = __webpack_public_path__ + "img/dlybg04.554e8624.png";